export const getInitialSurveyPermissions = (allSurveys: SurveyResponse[]) => {
  return allSurveys.map(({ survey }) => ({
    name: survey.name,
    token: survey.token,
    has_permission: false,
  }))
}

export const getInitialDashboardPermissions = (allDashboards: DashboardResponse[]) => {
  return allDashboards.map((dashboard) => ({
    name: dashboard.name,
    token: dashboard.token,
    has_permission: false,
  }))
}

interface SurveyResponse {
  survey: {
    id: number
    token: string
    name: string
  }
}

interface DashboardResponse {
  id: number
  token: string
  name: string
}



// WEBPACK FOOTER //
// ./src/components/CustomRoleForm/utils.tsx